import { useEffect, useState } from 'react';
import { subscribe } from 'utils/FirebaseUtils';

export function useFireStoreSubscription({ path }) {
  const [loading, setLoading] = useState(true);
  const [snapshot, setSnapshot] = useState(undefined);
  const [error, setError] = useState();

  const handleChange = (docSnapshot) => {
    setLoading(false);
    setSnapshot(docSnapshot);
    setError(null);
  };

  const handleError = (error) => {
    if (error) {
      setError(error);
      setSnapshot(undefined);
      setLoading(false);
    } else {
      setError(null);
    }
  };

  useEffect(() => {
    const unsubscribe = subscribe(path, {
      next: handleChange,
      error: handleError,
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return { loading, snapshot, error };
}
